<!-- 用户登录与信息卡片 -->
<template>
  <div class="user-card">
    <!-- no login -->
    <div class="avatar-box avatar-nologin" v-if="!userId">
      <img class="avatar" src="@/assets/global/avatar.png" alt="avatar">
      <div class="click-login" @click="doLogin">点击登录</div>
    </div>
    <!-- no login end -->

    <!-- login -->
    <div class="avatar-box avatar-login" :class="{ 'avatar-vip': isVip, 'avatar-notvip': !isVip }" v-if="userId">
      <img class="avatar" :src="avatarUrl || require('../../assets/global/avatar.png')" :onerror="defaultAvartarUrl" alt="avatar">
      <div class="userinfo">
        <div class="nickname">{{nickname}}</div>
        <div class="uid">工爸ID：{{userId}}</div>
      </div>
      <div class="logout" @click="doLogout" v-if="showLogout">退出登录</div>
    </div>
    <!-- login end -->

    <template v-if="showText">
      <!-- no login -->
      <div class="vip-tip vip-tip-nologin" v-if="showNoLoginText && !userId">{{noLoginText}}</div>
      <!-- login without vip -->
      <div class="vip-tip vip-tip-login" v-else-if="showNotVipText && !isVip">{{notVipText}}</div>
      <!-- vip login -->
      <div class="vip-tip vip-tip-viplogin" v-else-if="showVipText">{{vipTextDp}}</div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { login, logout } from '@/utils/login'
import { vipExpireFormatter } from '@/filters/index'

export default {
  name: 'UserCard',
  props: {
    // 显示退出按钮
    showLogout: {
      type: Boolean,
      default: true,
    },
    // 显示文本信息
    showText: {
      type: Boolean,
      default: true,
    },
    // 显示未登录时的文本
    showNoLoginText: {
      type: Boolean,
      default: true,
    },
    noLoginText: {
      type: String,
      default: '登录购买VIP会员'
    },
    // 显示非vip时的文本
    showNotVipText: {
      type: Boolean,
      default: true,
    },
    notVipText: {
      type: String,
      default: '您还不是口袋故事vip',
    },
    // 显示是vip时的文本
    showVipText: {
      type: Boolean,
      default: true,
    },
    vipText: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      vipTextDp: '',
      vipExpireDate: '',
      defaultAvartarUrl: 'this.src="' + require('../../assets/global/avatar.png') + '"',
    }
  },
  computed: {
    ...mapGetters([
      'userId',
      'mobile',
      'nickname',
      'avatarUrl',
      'isVip',
      'vipCount'
    ]),
  },
  watch: {
    vipCount: {
      immediate: true,
      handler: function () {
        let time = new Date().getTime() + this.vipCount * 24 * 60 * 60 * 1000
        this.vipExpireDate = vipExpireFormatter(time)
        if (this.vipText === '') this.vipTextDp = `${this.vipExpireDate} VIP到期`
      }
    }
  },
  methods: {
    doLogin() {
      login(window.location.href)
    },
    doLogout() {
      logout(window.location.href)
    },
  },
  created() {
    
  },
  mounted() {
    
  },
}
</script>

<style lang="less" scoped>
  @import "~@/styles/fn";
  @avatar-gap: .24rem;
  .addVipIcon(@url) {
    content: "";
    display: block;
    position: absolute;
    top: 1rem;
    left: 1rem;
    width: .36rem;
    height: .36rem;
    .bg(@url);
  }
  .user-card {
    position: relative;
    margin: 0 auto;
    width: 6.7rem;
    height: 3.2rem;
    border-radius: .26rem;
    .bg("~@/assets/global/user-card.png");
  }
  .avatar-box {
    position: relative;
    padding: .32rem;
    .avatar {
      position: relative;
      width: 1rem;
      height: 1rem;
      border-radius: 100%;
    }
    .click-login {
      padding-left: @avatar-gap;
      font-size: .4rem;
      font-weight: 500;
      color: #fff;
    }
  }
  .avatar-nologin {
    .avatar, .click-login {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .avatar-login {
    display: flex;
    .userinfo {
      flex: 1;
      padding-left: @avatar-gap;
      .nickname {
        margin-bottom: .08rem;
        .ellipsis(3.2rem);
        font-size: .4rem;
        color: #fff;
      }
      .uid {
        font-size: .28rem;
        color: rgba(255,255,255,.64);
      }
    }
    .logout {
      align-self: center;
      width: 1.28rem;
      height: .48rem;
      line-height: .48rem;
      font-size: .24rem;
      color: #fff;
      text-align: center;
      border: 1px solid #fff;
      border-radius: 200px;
    }
  }

  .avatar-notvip::after {
    .addVipIcon("~@/assets/global/notvip-icon.png");
  }
  .avatar-vip::after {
    .addVipIcon("~@/assets/global/vip-icon.png");
  }

  .vip-tip {
    position: absolute;
    right: .32rem;
    bottom: .32rem;
    font-size: .28rem;
    font-weight: bold;
    &-nologin, &-login {
      color: rgba(255,255,255,.64);
    }
    &-viplogin {
      color: #fedc42;
    }
  }
</style>
